import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Scroll restoration helper
import ScrollToTop from "./components/ScrollToTop";

// Main Platform Experience Pages
import LandingPage from "./Pages/LandingPage.jsx";
import BuyerPage from "./Pages/BuyerPage.jsx";
import SellerPage from "./Pages/SellerPage.jsx";
import OperatorPage from "./Pages/OperatorPage.jsx";
import HowItWorksPage from "./Pages/HowItWorksPage.jsx";
import CategoriesPage from "./Pages/CategoriesPage.jsx";
import AboutPage from "./Pages/AboutPage.jsx";
import ContactPage from "./Pages/ContactPage.jsx";
import FaqPage from "./Pages/FaqPage.jsx";
import TermsPage from "./Pages/TermsPage.jsx";
import PrivacyHubPage from "./Pages/PrivacyHubPage.jsx";

// Platform Access & Onboarding Application
import RequestAccessPage from "./Pages/RequestAccessPage.jsx";

// B2B Industry Blog & Editorial Portal Pages
import BlogListPage from "./Pages/BlogListPage.jsx";
import BlogDetailPage from "./Pages/BlogDetailPage.jsx";
import BlogLogin from "./Pages/BlogLogin.jsx";
import BlogAdminDashboard from "./Pages/BlogAdminDashboard.jsx";

// Privacy Policy Pages
import PrivacyPolicy from "./Pages/PrivacyPolicy.jsx";
import SellerPrivacyPolicy from "./Pages/SellerPrivacyPolicy.jsx";
import PrivacyPolicySellDeliver from "./Pages/PrivacyPolicySellDeliver.jsx";

// Account Deletion Forms
import BuyerDeleteAccount from "./Pages/BuyerDeleteAccountPlayStore.jsx";
import SellerDeleteAccountPlayStore from "./Pages/SellerDeleteAccountPlayStore.jsx";
import JResDeleteAccountPlayStore from "./Pages/JResDeleteAccountPlayStore.jsx";

// 404 Catch-all
import NotFound from "./Pages/NotFound.jsx";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Main Landing & Decision Experience */}
        <Route path="/" element={<LandingPage />} />

        {/* Triple Conversion Funnels: Buyer, Seller, Operator */}
        <Route path="/buyer" element={<BuyerPage />} />
        <Route path="/buyer-app" element={<BuyerPage />} />
        <Route path="/seller" element={<SellerPage />} />
        <Route path="/seller-app" element={<SellerPage />} />
        <Route path="/operator" element={<OperatorPage />} />
        <Route path="/operator-app" element={<OperatorPage />} />
        <Route path="/operator-hub" element={<OperatorPage />} />
        <Route path="/franchise" element={<OperatorPage />} />

        {/* Official Onboarding & Access Application */}
        <Route path="/apply" element={<RequestAccessPage />} />
        <Route path="/request-access" element={<RequestAccessPage />} />
        <Route path="/onboarding" element={<RequestAccessPage />} />

        {/* B2B Industry Blog Public Routes */}
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />

        {/* Dedicated Blog Author & Editorial Portal (Isolated from standard login) */}
        <Route path="/blog/login" element={<BlogLogin />} />
        <Route path="/blog-portal/login" element={<BlogLogin />} />
        <Route path="/blog/admin" element={<BlogAdminDashboard />} />
        <Route path="/blog-portal/dashboard" element={<BlogAdminDashboard />} />

        {/* Platform Architecture & Directory */}
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyHubPage />} />

        {/* Dedicated Privacy Policies */}
        <Route path="/buyerprivacy" element={<PrivacyPolicy />} />
        <Route path="/sellerprivacy" element={<SellerPrivacyPolicy />} />
        <Route
          path="/selldeliverprivacy"
          element={<PrivacyPolicySellDeliver />}
        />

        {/* Account Deletion Forms */}
        <Route path="/buyer-account-delete" element={<BuyerDeleteAccount />} />
        <Route
          path="/seller-account-delete"
          element={<SellerDeleteAccountPlayStore />}
        />
        <Route
          path="/jres-account-delete"
          element={<JResDeleteAccountPlayStore />}
        />

        {/* Catch-all: 404 Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
